import {injectIntl} from 'react-intl';

export default () => Component => {
    return injectIntl(Component);
};
